import './style.scss';

const { Modal, EventTypes, ActionCreators, store } = __app__;

const templates = {
	modal: `
		<div class="modal fade location-select-modal" tabindex="-1">
			<div class="modal-dialog  modal-dialog-centered" style="max-width: 100%; width: 55rem;">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal">
							<svg class="icon-svg" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
								<path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
							</svg>
						</button>
					</div>
					<div class="modal-body"></div>
				</div>
			</div>
		</div>
	`
};

export function useLocationConfirmer(el)
{
	if (store.state.location.confirmed)
		return;

	if (window.outerWidth <= store.state.ui.breakpoints.md)
		return;

	const $el = $(el).popover({
		animation: true,
		html: true,
		template: document.querySelector('[data-template-id="location-confirm-template"]').innerHTML,
		content: document.querySelector('[data-template-id="location-confirm-content"]').innerHTML,
		placement: 'bottom', 
		trigger: 'manual'
	});

	setTimeout(() => $el.popover('show'), 2000);

	$el.on('shown.bs.popover', () => {
		const popover = $el.data('bs.popover')
		const tipElement = popover.getTipElement();
		const btns = tipElement.querySelectorAll('.btn');
		
		if (btns[0])
		{
			btns[0].addEventListener('click', event => {
				event.preventDefault();
				store.dispatch(ActionCreators.confirmLocation());
			});
		}

		if (btns[1])
		{
			btns[1].addEventListener('click', event => {
				event.preventDefault();
				Modal.load(
					$el.attr('href'), 
					{ 
						method: 'POST', 
						extendOptions: { 
							templates 
						} 
					}, 
					{ 
						LOCATION_SWITCHER: 'Y' 
					}
				);
			});
		}
	});

	store.subscribe(EventTypes.LOCATION_CONFIRMED, () => {
		$el.popover('hide');
	});
}

function onReady()
{
	document.addEventListener(
		'click', 
		event => {
			if (event.target.dataset.toggle === 'location-switcher')
			{
				event.preventDefault();
				Modal.load(
					event.target.getAttribute('href'), 
					{ 
						method: 'POST', 
						extendOptions: { 
							templates 
						} 
					}, 
					{ 
						LOCATION_SWITCHER: 'Y' 
					}
				);
			}
		}, 
		true
	);

}

document.addEventListener('DOMContentLoaded', onReady); 
